import { Navigate, useParams } from "react-router-dom";
import { useInterviewFlowState } from "@/features/interviewFlow";

const STEP_ROUTES: Record<number, string> = {
  0: "",
  1: "p2",
};

interface InterviewRoomGuardProps {
  children: React.ReactNode;
}

export function InterviewRoomGuard({ children }: InterviewRoomGuardProps) {
  const { step, validationData } = useInterviewFlowState();
  const { token } = useParams();

  if (!validationData) return null;

  const isPanelist = validationData.role === "panel";

  // Panelists do not require verification proofs
  if (isPanelist) {
    return <>{children}</>;
  }

  // If candidate lacks verification proofs, redirect them back to their appropriate pre-interview step
  if (!validationData.proofs) {
    const currentStep = step ?? validationData.step ?? 0;
    const subPath = STEP_ROUTES[currentStep] ?? "";
    return <Navigate to={`/i/${token}/${subPath}`} replace />;
  }

  return <>{children}</>;
}
